import { render, staticRenderFns } from "./BsTreegridItems.vue?vue&type=template&id=c4207bb6&scoped=true&"
import script from "./BsTreegridItems.vue?vue&type=script&lang=js&"
export * from "./BsTreegridItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4207bb6",
  null
  
)

export default component.exports